import React from "react";
import useUpload from "../hooks/useUpload";
import useUploadDocument from "../../hooks/useUploadDocument";
import TextInput from "../../../components/elements/form/TextInput";
import SelectDate from "../../../components/elements/form/SelectDate";
import UploadInput from "../../../components/elements/form/UploadInput";

import Button from "../../../components/elements/form/Button";
import { update_document } from "../../../service/api/document";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store";
import { FaFileLines } from "react-icons/fa6";
import { setTitle } from "../../../store/slices/navbar";

const EditUploadDocument = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loading = useAppSelector(({ loading }) => loading.loading);

  // This should be the document returned by your backend when opening the Edit screen
  const document = useAppSelector((state) => state.document.document);

  React.useEffect(() => {
    if (document?.name) {
      dispatch(setTitle(`Edit - ${document.name}`));
    }
  }, [document?.name, dispatch]);

  // IMPORTANT: pass existing data into the hook
  const { data, dataSet, error, errorSet, onValidate, onChange } =
    useUpload(document);

  const { progress, uploadDocument } = useUploadDocument();

  const handleSubmit = () => {
    if (onValidate()) {
      update_document(dispatch, data, navigate); // will include id
    }
  };

  return (
    <div className="">
      <div className="bg-white rounded-xl shadow-sm">
        <div className="p-6 space-y-6">
          <div className="w-full">
            <UploadInput
              title="Upload Document"
              name="Oppunity Document"
              label="PDF Document"
              completed={data.path ? true : false}
              status={error.path}
              loading={progress}
              onChange={async (file: File | File[]) => {
                const fileToUpload = Array.isArray(file) ? file[0] : file;
                const path = await uploadDocument(
                  fileToUpload,
                  "Oppunity Document"
                );
                if (path && path.length > 0) {
                  const filePath = path[0].baseUrl + "/" + path[0].path;
                  dataSet((prev) => ({
                    ...prev,
                    path: filePath,
                  }));
                  errorSet((prev) => ({ ...prev, path: "" }));
                }
              }}
            />
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <TextInput
              label="Document Name"
              name="name"
              value={data.name}
              type="text"
              placeholder="Enter document name"
              required={true}
              status={error.name}
              onChange={onChange}
              icon={<FaFileLines size={20} />}
            />

            <TextInput
              label="Issuing Body"
              name="issuing_body"
              value={data.issuing_body}
              type="text"
              placeholder="Enter issuing body"
              required={true}
              status={error.issuing_body}
              onChange={onChange}
            />
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <SelectDate
              label="Issuing Date"
              name="issuing_date"
              value={data.issuing_date}
              placeholder="Select issuing date"
              required={true}
              status={error.issuing_date}
              onChange={onChange}
            />

            <SelectDate
              label="Expiring Date"
              name="expiring_date"
              value={data.expiring_date}
              placeholder="Select expiring date"
              required={true}
              status={error.expiring_date}
              onChange={onChange}
            />
          </div>

          <div className="flex justify-end">
            <Button
              title="Update Document"
              loading={loading}
              onHandler={handleSubmit}
              className="w-full md:w-auto px-6 py-2 bg-primary-600 hover:bg-primary-700 text-white font-medium rounded-lg transition-colors duration-200"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUploadDocument;
